import { render } from "./Portfolio.vue?vue&type=template&id=0cd904f1&scoped=true&ts=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=0cd904f1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd904f1"]])

export default __exports__